import {
  BadgeCheck, Briefcase, HandHeart, GraduationCap, Sprout, Users, BookOpen, Crown,
} from "lucide-react";

const BADGE_ICON = {
  verified_professional: BadgeCheck,
  verified_employee: Briefcase,
  verified_volunteer: HandHeart,
  verified_intern: Sprout,
  verified_mentor: Users,
  verified_founder: Crown,
  verified_trainer: BookOpen,
  verified_student: GraduationCap,
};

export default function BadgeGrid({ badges = [], allPossible = true }) {
  const POSSIBLE_KEYS = ["verified_professional", "verified_employee", "verified_intern", "verified_volunteer", "verified_mentor", "verified_trainer", "verified_student", "verified_founder"];
  const earned = new Map(badges.map((b) => [b.key, b]));

  const list = allPossible
    ? POSSIBLE_KEYS.map((k) => earned.get(k) || { key: k, label: k.replace(/_/g, " "), earned: false })
    : badges;

  return (
    <div className="grid grid-cols-4 sm:grid-cols-8 gap-3" data-testid="badge-grid">
      {list.map((b) => {
        const Icon = BADGE_ICON[b.key] || BadgeCheck;
        const isEarned = allPossible ? earned.has(b.key) : true;
        return (
          <div
            key={b.key}
            className={`aspect-square flex flex-col items-center justify-center text-center border rounded-sm p-2 transition-all ${
              isEarned
                ? "border-ec-emerald/40 bg-ec-emerald/5 text-ec-ink"
                : "border-dashed border-ec-line bg-ec-mute/40 text-ec-ink-soft opacity-60"
            }`}
            data-testid={`badge-${b.key}`}
            title={b.label}
          >
            <Icon className={`w-6 h-6 ${isEarned ? "text-ec-emerald" : "text-ec-ink-soft"}`} />
            <span className="text-[9px] font-bold uppercase tracking-wider mt-1 leading-tight capitalize">
              {b.label.replace("Verified ", "")}
            </span>
          </div>
        );
      })}
    </div>
  );
}
